<div class="rectangle-container">
    <div class="rx-app-flex-container-column">
        <div class="rx-card-title-print rx-app-flex rx-app-flex-container-row">
            <div class="general-info">
                <strong>{{ 'DoctorSection.Doctor' | translate }}:</strong>
                {{ doctorName || '--' }}
            </div>
        </div>
        <div class="general-info-body rx-app-flex-container-row">
            <div class="column-primary">
                <rx-info-block
                    class="info-box rx-app-flex rx-app-flex-container-column"
                    [fields]="[
                        { name: 'PrintRx.Practice', value: practice, isInline: true },
                        { name: 'PrintRx.Ship-to-Address', value: shipToAddress, isInline: true }
                    ]"
                ></rx-info-block>
            </div>
            <hr class="separator" />
            <div class="info-box rx-app-flex rx-app-flex-container-column">
                <rx-info-block
                    [fields]="[
                        { name: 'GeneralRxData.CaseType', value: caseType$ | async, isInline: true },
                        { name: 'GeneralRxData.ScanDate', value: scanDate | date: (dateFormat$ | async), isInline: true },
                        { name: 'GeneralRxData.DueDate', value: dueDate | date: (dateFormat$ | async):'UTC', isInline: true }
                    ]"
                ></rx-info-block>
            </div>
            <hr class="separator" />
            <div class="rx-app-flex rx-app-flex-container-column">
                <rx-info-block
                    class="info-box info-box-signature rx-app-flex rx-app-flex-container-column"
                    [fields]="[
                        {
                            name: 'GeneralRxData.Signature',
                            value: signature,
                            isSignature: true
                        },
                        { name: 'GeneralRxData.License', value: license, isInline: true }
                    ]"
                ></rx-info-block>
            </div>
        </div>
    </div>
</div>
